module.exports = __webpack_public_path__ + "img/paynow_4x.0c3a6876.png";